import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import {ClientTable, Event} from 'vue-tables-2';
import moment from 'moment';
import './assets/css/bootstrap.css'
import './assets/css/bootstrap-extended.min.css'
import './assets/css/colors.css'
import './assets/css/components.css'
import './assets/css/horizontal-menu.css'
import './assets/style.css'
// import './assets/main.scss'
import VueApexCharts from 'vue-apexcharts'
import interceptorsSetup from './helpers/axios'
import toast from './helpers/toast'
import MyChildRowToggler from '@/components/table/MyChildRowToggler'
import FilterForm from '@/components/table/FilterForm'
import DateRangePicker from "@gravitano/vue-date-range-picker";
import 'moment/locale/ru'

require('@/store/subscriber')
Vue.component("apexchart", VueApexCharts);
interceptorsSetup()
axios.defaults.baseURL = 'https://api.brushme.com.ua/prv/drop/';
// Vue.use(BootstrapVue)
Vue.prototype.$toast = toast
Vue.prototype.$moment = moment;
window.moment = moment;
Vue.use(Event)
// Vue.component('apexchart', VueApexCharts)
Vue.use(ClientTable, {}, false, 'bootstrap4', {
    'childRowToggler': MyChildRowToggler,
    'genericFilter': FilterForm
});
Vue.use(DateRangePicker);
Vue.config.productionTip = true
store.dispatch('getLexicon');
store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})

